exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".descitemclass[_v-7a908b12]{margin-bottom:5px;margin-top:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-7a908b12&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/tables/table-t6/table.vue
// module id = 180
// module chunks = 0